<template>
  <div class="input-wrapper all-day-wrapper">
    <div class="title-wrapper position-relative">
      <span class="ver-center">Is this a video group?</span>
    </div>
    <div class="content-wrapper position-relative checkbox-container">
      <label class="toggle float-right">
        <input
          type="checkbox"
          class="input-btn"
          :checked="isVideo"
          @change="setIsVideo(!isVideo)"
        />
        <div class="slide-toggle slide-toggle-appoitment"></div>
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters("group", {
      isVideo: "getIsVideo"
    })
  },
  methods: {
    ...mapMutations("group", {
      setIsVideo: "setIsVideo"
    })
  }
};
</script>
